export default "__VITE_ASSET__e8bRIEut__"